// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"37e447de","547":"37e447de"}[chunkId] + ".chunk.css";
};